import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import LoginLogo from '../../assets/svg/login_logo.svg';
import NotificationIcon from '../../assets/svg/Bell.svg';
import NotifyBellIcon from '../../assets/svg/NotifyBell.svg';
import left_arrow from '../../assets/svg/left_arrow.svg';
import { useNavigate } from 'react-router-dom';
import DP from '../../assets/svg/login_logo.svg';
import Avatar from 'react-avatar';
import { getNotifications, getUserById } from '../../../builder/services/api/implementation/impl';
import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import socket from '../../../../socket';
import { useProjectsList } from '../../../../contexts/ProjectsContext';

const Header = ({ data, onBack, backArrow, onProjectSelect, showProjectSelector = false, children }) => {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const { projects, projectsForDropdown, isProjectsLoading } = useProjectsList();
  const navigate = useNavigate();
  const widgetRef = useRef(null);
  const iconRef = useRef(null);
  // Project selector dropdown state/refs
  const projectTriggerRef = useRef(null);
  const projectDropdownRef = useRef(null);
  const [showProjectDropdown, setShowProjectDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
  const userId = Cookies.get('userId');
  const [notify, setNotify] = useState(false);
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);

  //user api call to get user details
  const { data: user } = useQuery({
    queryKey: ['user', userId],
    queryFn: () => getUserById(userId),
    enabled: !!userId
  });

  console.log({ user });

  // Local state for service provider categories
  const [notifications, setNotifications] = useState([]);

  // Fetch all service provider categories
  const { data: allNotifications } = useQuery({
    queryKey: ['getNotifications'],
    queryFn: getNotifications
  });

  useEffect(() => {
    if (Array.isArray(allNotifications?.data)) {
      setNotifications(allNotifications?.data);
    }
  }, [allNotifications]);

  // Initialize first project when projects are loaded
  useEffect(() => {
    if (projects?.length > 0 && !selectedProject) {
      setCurrentProjectIndex(0);
      setSelectedProject(projects[0]);
      if (onProjectSelect) {
        onProjectSelect(projects[0]);
      }
    }
  }, [projects, selectedProject, onProjectSelect]);

  // Handle project selection
  const handleProjectSelect = (project, index) => {
    setCurrentProjectIndex(index);
    setSelectedProject(project);
    setShowProjectDropdown(false);
    if (onProjectSelect) {
      onProjectSelect(project);
    }
  };

  // Helpers for previous/next project navigation
  const goToPreviousProject = () => {
    if (!projects || projects.length === 0) return;
    const newIndex = currentProjectIndex === 0 ? projects.length - 1 : currentProjectIndex - 1;
    handleProjectSelect(projects[newIndex], newIndex);
  };

  const goToNextProject = () => {
    if (!projects || projects.length === 0) return;
    const newIndex = currentProjectIndex === projects.length - 1 ? 0 : currentProjectIndex + 1;
    handleProjectSelect(projects[newIndex], newIndex);
  };

  // Calculate dropdown position for project selector
  const updateProjectDropdownPosition = () => {
    if (!projectTriggerRef.current) return;

    const rect = projectTriggerRef.current.getBoundingClientRect();
    // Use viewport coordinates for a fixed-position portal
    let top = rect.bottom + 4;
    let left = rect.left;

    const dropdownMaxHeight = 240; // 15rem
    if (top + dropdownMaxHeight > window.innerHeight) {
      top = rect.top - dropdownMaxHeight - 4;
    }

    setDropdownPosition({ top, left, width: rect.width });
  };

  // Toggle the notification widget
  const toggleWidget = () => {
    setIsWidgetOpen(!isWidgetOpen);
    setNotify(false);
  };

  // Close the widget when clicking outside of it, and close project dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        widgetRef.current &&
        !widgetRef.current.contains(event.target) &&
        !iconRef.current.contains(event.target)
      ) {
        setIsWidgetOpen(false);
      }

      if (
        projectDropdownRef.current &&
        !projectDropdownRef.current.contains(event.target) &&
        projectTriggerRef.current &&
        !projectTriggerRef.current.contains(event.target)
      ) {
        setShowProjectDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Keep dropdown aligned on scroll/resize
  useEffect(() => {
    let timeoutId = null;
    const handleScrollOrResize = () => {
      if (!showProjectDropdown) return;
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => updateProjectDropdownPosition(), 10);
    };

    if (showProjectDropdown) {
      updateProjectDropdownPosition();
      window.addEventListener('scroll', handleScrollOrResize, true);
      window.addEventListener('resize', handleScrollOrResize);
      return () => {
        if (timeoutId) clearTimeout(timeoutId);
        window.removeEventListener('scroll', handleScrollOrResize, true);
        window.removeEventListener('resize', handleScrollOrResize);
      };
    }
  }, [showProjectDropdown]);

  const formatTimeDifference = (updatedAt) => {
    const currentTime = new Date();
    const updatedTime = new Date(updatedAt);
    const diffInMilliseconds = currentTime - updatedTime;
    const diffInMinutes = Math.max(0, Math.floor(diffInMilliseconds / (1000 * 60)));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));

    if (diffInHours >= 24) {
      const days = Math.floor(diffInHours / 24);
      const remainingHours = diffInHours % 24;
      return `${days}d${remainingHours > 0 ? ` ${remainingHours}h` : ''}`;
    } else if (diffInHours >= 1) {
      return `${diffInHours}h`;
    } else {
      return `${diffInMinutes}m`;
    }
  };

  useEffect(() => {
    const handlePost = async (res) => {
      console.log('post response', res);

      try {
        const userId = Cookies.get('userId'); // Retrieve userId from cookies
        if (!userId) return;

        // Fetch user details to get associated companies
        const userResponse = await getUserById(userId);
        const userCompanies = userResponse?.companies || []; // Assuming 'companies' is an array

        // Check if the post's company matches any of the user's companies
        if (userCompanies.includes(res.company)) {
          setNotify(true);
        }
      } catch (error) {
        console.error('Error fetching user details in handlePost:', error);
      }
    };

    const handleComment = (res) => {
      console.log('comment response', res);

      const userId = Cookies.get('userId'); // Retrieve userId from cookies
      const createdBy = res.post.created_by;

      // Ensure both userId and createdBy are in the same format
      const userIdStr = String(userId);
      const createdByStr = String(createdBy);

      if (userIdStr === createdByStr) {
        setNotify(true);
      }
    };

    const handleTagInPost = (res) => {
      console.log('Tag in Post', res);
    };

    const handleTagInComment = (res) => {
      console.log('Tag in comment', res);
    };

    const handleReply = (res) => {
      console.log('Reply response', res);
      const userId = Cookies.get('userId'); // Retrieve userId from cookies
      const createdBy = res.comment.created_by;

      // Ensure both userId and createdBy are in the same format
      const userIdStr = String(userId);
      const createdByStr = String(createdBy);

      if (userIdStr === createdByStr) {
        setNotify(true);
      }
    };

    const handleLike = (res) => {
      console.log('Like Response', res);
      const userId = Cookies.get('userId'); // Retrieve userId from cookies
      const createdBy = res.post.created_by;

      // Ensure both userId and createdBy are in the same format
      const userIdStr = String(userId);
      const createdByStr = String(createdBy);

      if (userIdStr === createdByStr) {
        setNotify(true);
      }
    };

    // Add socket listeners
    socket.on('Post', handlePost);
    socket.on('Comment', handleComment);
    socket.on('Reply', handleReply);
    socket.on('Like', handleLike);
    socket.on('TAG IN POST', handleTagInPost);
    socket.on('TAG IN COMMENT', handleTagInComment);

    // Cleanup socket listeners on unmount
    return () => {
      socket.off('Post', handlePost);
      socket.off('Comment', handleComment);
      socket.off('Reply', handleReply);
      socket.off('Like', handleLike);
      socket.off('TAG IN POST', handleTagInPost);
      socket.off('TAG IN COMMENT', handleTagInComment);
    };
  }, []); // Empty dependency array ensures this runs only once

  return (
    <div className="relative flex w-full justify-between items-center px-6 py-4 bg-white border-b-2 z-10">
      <div className="flex items-center gap-4">
        <div className="flex justify-between items-center space-x-1 text-stone-700 font-semibold text-lg">
          {backArrow && (
            <img
              className="inline-block h-8 w-8 rounded-full ring-3 ring-white cursor-pointer hover:scale-105 transition-all duration-300"
              src={left_arrow}
              alt="Logo_image"
              onClick={onBack ? onBack : () => navigate(-1)}
            />
          )}

          <span>{data?.name}</span>
        </div>

        {children && (
          <div className="flex items-center gap-3">
            {children}
          </div>
        )}
      </div>

      <div className="flex gap-4 relative">
        {/* Project Navigation (inline) */}
        {showProjectSelector && (
          <div className="flex items-center gap-2 p-1 rounded-lg bg-white">
            <button
              type="button"
              onClick={goToPreviousProject}
              disabled={!projects || projects.length <= 1}
              className="flex items-center justify-center w-8 h-9 bg-gray-100 hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors rounded-md">
              <svg
                className="w-4 h-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <button
              ref={projectTriggerRef}
              type="button"
              onClick={() => setShowProjectDropdown(!showProjectDropdown)}
              className="flex items-center gap-2 px-4 py-[0.3rem] bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 transition-colors min-w-[10rem]">
              <span className="font-medium text-gray-900 text-sm whitespace-nowrap text-center w-full">
                {selectedProject?.name || projects?.[currentProjectIndex]?.name || 'Loading...'}
              </span>
            </button>

            <button
              type="button"
              onClick={goToNextProject}
              disabled={!projects || projects?.length <= 1}
              className="flex items-center justify-center w-8 h-9 bg-gray-100 hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors rounded-md">
              <svg
                className="w-4 h-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        )}

        <div className="relative">
          {notify && (
            <div className="bg-[green] absolute broder rounded-md h-[6px] w-[6px] top-[0.45rem] right-[0.3rem] "></div>
          )}
          {!notify && (
            <img
              ref={iconRef}
              className="inline-block h-8 w-8 rounded-full ring-3 ring-white cursor-pointer"
              src={NotificationIcon}
              alt="Notification_image"
              onClick={toggleWidget} // Toggle widget on icon click
            />
          )}

          {notify && (
            <img
              ref={iconRef}
              className="inline-block h-8 w-8 rounded-full ring-3 ring-white cursor-pointer"
              src={NotifyBellIcon}
              alt="Notification_image"
              onClick={toggleWidget} // Toggle widget on icon click
            />
          )}

          {/* Project Dropdown Portal */}
          {showProjectDropdown &&
            projects &&
            projects?.length > 0 &&
            ReactDOM.createPortal(
              <div
                ref={projectDropdownRef}
                className="fixed bg-white border border-gray-200 rounded-md shadow-lg z-[10000] max-h-60 overflow-y-auto"
                style={{
                  top: dropdownPosition.top,
                  left: dropdownPosition.left,
                  width: dropdownPosition.width
                }}>
                {projects?.map((project, index) => (
                  <button
                    key={project.id || index}
                    type="button"
                    onClick={() => handleProjectSelect(project, index)}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${
                      index === currentProjectIndex
                        ? 'bg-blue-50 text-blue-700 font-medium'
                        : 'text-gray-700'
                    }`}>
                    {project.name}
                  </button>
                ))}
              </div>,
              document.body
            )}

          {isWidgetOpen &&
            ReactDOM.createPortal(
              <div
                ref={widgetRef}
                className="fixed right-4 top-16 w-80 bg-white border rounded-lg shadow-lg z-[10000] pb-2">
                <div className="p-4 border-b flex justify-between items-center">
                  <h3 className="text-lg font-semibold">Notifications</h3>
                  <button onClick={toggleWidget} className="text-gray-500">
                    &times;
                  </button>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'start',
                    flexDirection: 'column',
                    gap: '0.2rem',
                    maxHeight: '22.5rem',
                    overflowY: 'auto',
                    zIndex: '10000'
                  }}>
                  {notifications?.map((notification) => (
                    <div
                      key={notification.id}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'start',
                        alignItems: 'center',
                        padding: '8px',
                        height: '60px',
                        width: '100%',
                        borderRadius: '8px',
                        border: '1px solid #f6f4f3',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        navigate(`/builder/post/${notification.id}`);
                        setIsWidgetOpen(false);
                      }}>
                      <Avatar name={notification.user?.name} size="35" round />
                      <div style={{ width: '90%', marginLeft: '10px' }}>
                        <p
                          style={{
                            color: 'black',
                            fontSize: '13px',
                            fontWeight: '500'
                          }}>
                          {notification.user?.name} {notification.content}
                        </p>
                        <p
                          style={{
                            color: 'grey',
                            fontSize: '13px',
                            width: '100%'
                          }}>
                          {formatTimeDifference(notification.updated_at) + ' '}
                        </p>
                      </div>
                      <div
                        style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          flexDirection: 'column'
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            width: '100%'
                          }}>
                          <div
                            style={{
                              backgroundColor: '#346C75',
                              height: '8px',
                              width: '8px',
                              borderRadius: '50%'
                            }}></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>,
              document.body
            )}
        </div>
        <button
          type="button"
          onClick={() => navigate('/builder/profile')}
          className="cursor-pointer rounded-full focus:outline-none focus:ring-2 focus:ring-[#49A4AB] focus:ring-offset-1">
          <Avatar
            name={user?.name || 'Anonymous'}
            size="30"
            round={true}
            maxInitials={2}
            color="#49A4AB"
          />
        </button>
      </div>
    </div>
  );
};

export default Header;
